import { Backdrop, CircularProgress, Typography } from '@mui/material'

interface P {
    open: boolean
    text: string
}

export const OverlayLoader = ({ open, text }: P) => {
    return (
        <Backdrop
            sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1, flexDirection: 'column', gap: 2 }}
            open={open}>
            <CircularProgress color='inherit' />
            <Typography variant='h6'>{text}</Typography>
        </Backdrop>
    )
}
